/* global Chart */
import i18n from 'l10n';
import _ from 'underscore';
import Chart from 'chartjs';
import Handlebars from 'handlebars';
import GenericView from 'js/views/generic.view';
import GroupModel from 'js/models/group.model';
import GroupsTilesView from 'js/views/groups.tiles.view';
import SatisfactionTemplate from 'js/templates/metrics.groups.tiles.hbs';
import RatingsTemplate from 'js/templates/satisfaction-ratings.report.hbs';
import SurveyResponderCollection from 'js/models/survey.responder.paginated.collection';
import PaginatedView from 'js/views/pagination.view';
import dhtmlx from 'dhtmlxAdapter';
import {debounce, el, on, tagName} from "../adapters/backbone-decorators";

require('interfaceAdapter');
require('metroHelpers');

@el('.container')
@tagName('span')
class SatisfactionView extends GenericView {

    constructor() {
        super();
        var self = this;
        this.template = Handlebars.compile(RatingsTemplate);

        this.groupsView = new GroupsTilesView({
            "el": "#satisfactionMetricGroups",
            "customTemplate": SatisfactionTemplate,
            "queryGroupsOnly": true
        });
        var groupsFetched = $.Deferred();
        this.groupsView.groupsCollection.fetch({
            success() {
                var engagementGroups = _.filter(self.groupsView.groupsCollection.models, function (model) {
                    if (model.get("groupType") === "query" && model.get("query").indexOf("satisfactionMetric") !== -1) {
                        model.set("isSatisfactionGroup", true);
                        return true;
                    }
                });
                self.groupsView.groupsCollection.models = engagementGroups;
                groupsFetched.resolveWith(self, engagementGroups);
            },
            error(model, status) {
                $.Notify.error(i18n.t("subscriber.nocontactsstatus") + ' = ' + status.status);
                groupsFetched.reject();
            }
        });

        // satisfaction Group Bounds Slider

        var $slider = $("#slider-range");
        $slider.slider({
            range: true,
            min: 0,
            max: 100,
            values: [50, 60],
            slide(event, ui) {
                var sliderValues = $("#slider-range").slider("option", "values");
                $("#satisfactionMinValue").text(ui.values[0]);
                $("#satisfactionMaxValue").text(ui.values[1]);
            }
        });

        //Show initial values
        var sliderValues = $slider.slider("option", "values");
        $("#satisfactionMinValue").text(sliderValues[0]);
        $("#satisfactionMaxValue").text(sliderValues[1]);

        this.surveyResponderCollection = new SurveyResponderCollection();
        this.surveyResponderCollection.on('sync', this.renderCollection, self);
        this.surveyCollectionUrl = this.surveyResponderCollection.url;
        this.surveyResponderCollection.getFirstPage().done(function (response, status, xhr) {
            self.showOrHidePagination(response);
        });

        groupsFetched.done(this.fetchAndRenderPie);
    }

    render() {
        super.render();
    }

    @debounce(800)
    @on('keyup .searchbox')
    searchByFilter() {
        var self = this;
        var filtersMap = {};

        this.$('.searchbox').each(function (index, elem) { //Hid search box in ratings since nobody has ever used it (TELLODY-609)
            if ($(elem).hasClass('filter_voucher')) {
                var text = $(elem).val().toLowerCase();//.replace(/\s+/g, '');

                if (text !== "") {
                    filtersMap["contactName"] = text;
                    self.surveyResponderCollection.filters = true;
                }
                self.surveyResponderCollection.search = self.surveyResponderCollection.search || !(!text);
            }
        });

        if (self.surveyResponderCollection.filters) {
            self.surveyResponderCollection.url = this.surveyCollectionUrl + "?" + "filtersMap=" + encodeURIComponent(JSON.stringify(filtersMap));
            self.inSearch = true;
        } else {
            self.surveyResponderCollection.url = this.surveyCollectionUrl;
            self.inSearch = false;
        }

        this.surveyResponderCollection.getFirstPage().done(function (response, status, xhr) {
            self.showOrHidePagination(response);
        });

        var $filterButtons = $(".filterButtons");
        if (!($($filterButtons.children(".filterRatings")[0]).hasClass("active"))) {
            $filterButtons.find(".active").removeClass("active");
            $($filterButtons.children(".filterRatings")[0]).addClass("active"); //add class "active" to the first Child, which is "ALL" button.
        }
    }

    fetchAndRenderPie() {
        var self = this;
        var engagementGroups = self.groupsView.groupsCollection.models;
        $.when(self.handlerPieChart()).done(function (pieChartResp) {

            //total satisfaction - happiness score
            var happinessScore = pieChartResp.happinessScore ? (pieChartResp.happinessScore).toFixed(0) : "-";
            var ratings = pieChartResp.numberOfRatings ? (pieChartResp.numberOfRatings).toFixed(0) : "-";
            //percent = (number_of_unique_contacts_submitted_survey) / (number_of_total_contacts) * 100
            var percent = pieChartResp.percentageOfRatings
                ? pieChartResp.percentageOfRatings < 1
                    ? pieChartResp.percentageOfRatings.toFixed(2)
                    : pieChartResp.percentageOfRatings.toFixed(0)
                : "-";
            $("#happinessScore").text(happinessScore);
            $("#happinessBasedOn").text(i18n.t('satisfaction.basedOnRatingFromCustomers', {
                ratings: ratings,
                percent: percent
            }));

            //pie charts
            var notGoodFrequencyPercent = pieChartResp.notGoodSatisfactionFrequency;
            var okayFrequencyPercent = pieChartResp.okaySatisfactionFrequency;
            var greatFrequencyPercent = pieChartResp.greatSatisfactionFrequency;

            $("#notGoodSatisfactionFrequency").text((notGoodFrequencyPercent).toFixed(0) + "%");
            $("#okaySatisfactionFrequency").text((okayFrequencyPercent).toFixed(0) + "%");
            $("#greatSatisfactionFrequency").text((greatFrequencyPercent).toFixed(0) + "%");

            var defaultGroups = {};
            _.each(engagementGroups, function (v, i) {
                switch (v.get('query')) {
                    case "in satisfactionMetricBetween(0, 0.35)":
                        defaultGroups.notGood = v;
                        var $notGoodSatisfactionGroup = $("#notGoodSatisfactionGroup");
                        $notGoodSatisfactionGroup.parents('.chart-pie-containerE').click(function () {
                            location.href = 'Contacts.htm#Group/' + v.get('id');
                        });
                        $notGoodSatisfactionGroup.text(v.get('size'));
                        v.once('change:size', function () {
                            $("#notGoodSatisfactionGroup").text(v.get('size'));
                        });
                        break;
                    case "in satisfactionMetricBetween(0.35, 0.66)":
                        defaultGroups.okay = v;
                        var $okaySatisfactionGroup = $("#okaySatisfactionGroup");
                        $okaySatisfactionGroup.parents('.chart-pie-containerE').click(function () {
                            location.href = 'Contacts.htm#Group/' + v.get('id');
                        });
                        $okaySatisfactionGroup.text(v.get('size'));
                        v.once('change:size', function () {
                            $("#okaySatisfactionGroup").text(v.get('size'));
                        });
                        break;
                    case "in satisfactionMetricBetween(0.66, 1)":
                        defaultGroups.great = v;
                        var $greatSatisfactionGroup = $("#greatSatisfactionGroup");
                        $greatSatisfactionGroup.parents('.chart-pie-containerE').click(function () {
                            location.href = 'Contacts.htm#Group/' + v.get('id');
                        });
                        $greatSatisfactionGroup.text(v.get('size'));
                        v.once('change:size', function () {
                            $("#greatSatisfactionGroup").text(v.get('size'));
                        });
                        break;
                }
            });

            if (self.greatPie) {
                self.greatPie.destroy();
            }
            if (self.okayPie) {
                self.okayPie.destroy();
            }
            if (self.notGoodPie) {
                self.notGoodPie.destroy();
            }

            var nonNotGoodFrequencyPercent = (100 - notGoodFrequencyPercent).toFixed(1);
            if (notGoodFrequencyPercent > 100) {
                nonNotGoodFrequencyPercent = 0;
            }

            var nonGreatFrequencyPercent = (100 - greatFrequencyPercent).toFixed(1);
            if (greatFrequencyPercent > 100) {
                nonGreatFrequencyPercent = 0;
            }

            var nonOkayFrequencyPercent = (100 - okayFrequencyPercent).toFixed(1);
            if (okayFrequencyPercent > 100) {
                nonOkayFrequencyPercent = 0;
            }

            var options = {
                responsive: false,
                percentageInnerCutout: 85,
                showTooltips: false,
                legendTemplate: "<% for (var i=0; i<segments.length; i++){%><h6 style=\"margin:0\"><span style=\"background-color:<%=segments[i].fillColor%>; width:30px; height:10px; display:inline-block\"></span><%if(segments[i].label){%> <%=segments[i].label%><%}%></h6><%}%>"
            };

            var dataNotGoodPie = [
                {
                    value: notGoodFrequencyPercent,
                    color: "#9C0000"
                },
                {
                    value: nonNotGoodFrequencyPercent,
                    color: "#FFC3C3"
                }
            ];

            var notGoodPie = $(self.el).find('#notGoodPie').get(0);
            var ctxGoodPie = notGoodPie.getContext("2d");
            ctxGoodPie.clearRect(0, 0, notGoodPie.width, notGoodPie.height);
            self.notGoodPie = new Chart(ctxGoodPie).Doughnut(dataNotGoodPie, options);

            var dataOkayPie = [
                {
                    value: okayFrequencyPercent,
                    color: "#272727"
                },
                {
                    value: nonOkayFrequencyPercent,
                    color: "#CBCBCB"
                }
            ];

            var okayPie = $(self.el).find('#okayPie').get(0);
            var ctxOkayPie = okayPie.getContext("2d");
            ctxOkayPie.clearRect(0, 0, okayPie.width, okayPie.height);
            self.okayPie = new Chart(ctxOkayPie).Doughnut(dataOkayPie, options);


            var dataGreatPie = [
                {
                    value: greatFrequencyPercent,
                    color: "#006F0F"
                },
                {
                    value: nonGreatFrequencyPercent,
                    color: "#B3FFBD"
                }
            ];

            var greatPie = $(self.el).find('#greatPie').get(0);
            var ctxGreatPie = greatPie.getContext("2d");
            ctxGreatPie.clearRect(0, 0, greatPie.width, greatPie.height);
            self.greatPie = new Chart(ctxGreatPie).Doughnut(dataGreatPie, options);
        });
    }

    handlerPieChart() {
        return $.ajaxDefaultQ({
            url: '/CampaignCloud/Report/SatisfactionPieChartData',
            type: 'POST',
            contentType: 'application/json',
            dataType: 'json'
        }).fail(function (response) {
            console.log(response);
        });
    }

    @on('click #createSatisfactionGroup')
    async newSatisfactionGroup() {
        var minValue = parseInt($("#satisfactionMinValue").text());
        var maxValue = parseInt($("#satisfactionMaxValue").text());

        if (this.hasInvalidInputs(minValue, maxValue)) {
            //do not create the group, if there are invalid input values
            return;
        }

        var model = new GroupModel({
            url() {
                return model.urlRoot;
            }
        });
        var groupTitle = i18n.t("satisfaction.newSatisfactionGroupName", {from: minValue, to: maxValue});
        var query = "in satisfactionMetricBetween(" + (minValue / 100) + ", " + (maxValue / 100) + ")";

        model.set("title", groupTitle);
        model.set("groupType", "query");
        model.set("query", query);
        model.url = function () {
            return model.urlRoot;
        };
        model.isNew = function () {
            return true;
        };

        try {
            const result = await dhtmlx.confirm({
                type: "confirm",
                text: i18n.t("satisfaction.createSatisfactionGroupBetween", {"min": minValue, "max": maxValue}),
                ok: i18n.t("message.yes"),
                cancel: i18n.t("message.no")
            });

            if (result) {
                const responseModel = await model.save(model.attributes);
                if (responseModel) {
                    const theModel = new GroupModel(responseModel.attributes);
                    this.groupsView.groupsCollection.add(theModel);
                    // var self = self.groupsView;
                    //used from another views, e.g. satisfaction.view, after creating a new group.
                    //pass the newly created model, get its appropriate data and render it.
                    this.groupsView.getAndUpdateGroupsCounters(responseModel);
                    $.Notify.show(i18n.t("instantWin.groupCreatedSuccessfully"));
                } else {
                    $.Notify.error(i18n.t("instantWin.errorCreatingGroup") + ". Outcome: " + responseModel);
                }
            }
        } catch (e) {
            console.info(e);
            $.Notify.error(i18n.t("instantWin.errorCreatingGroup"));
        }
    }

    hasInvalidInputs(minValue, maxValue) {
        if (minValue >= maxValue) {
            dhtmlx.alert(i18n.t("engagement.checkEngagementBoundaries"));
            return true;
        } else if (minValue.length === 0 || maxValue.length === 0) {
            dhtmlx.alert(i18n.t("engagement.fieldMustNotBeEmpty"));
            return true;
        } else if (isNaN(minValue) || isNaN(maxValue)) {
            dhtmlx.alert(i18n.t("engagement.useNumbersAlert"));
            return true;
        }

        return false;
    }

    renderCollection() {
        var self = this;
        //getting the value the user entered for search
        var $searchbox = $('.searchbox');
        this.val = $searchbox.val();

        if (this.paginationReport) {
            this.paginationReport.remove();
        }
        // Render collection the 1st time
        this.paginationReport = new PaginatedView({collection: self.surveyResponderCollection});
        this.paginationReport.render();
        // Replace view's pagination
        $('#pagination-report').html(this.paginationReport.$el);
        var tempTemplate = self.template({responders: self.surveyResponderCollection.data});
        this.$('#ratings-report-container').html(tempTemplate);

        //this command writes in searchbox the value entered
        //needed to persist value upon rendering
        $searchbox.val(self.val);

        setTimeout(function () {
            $(".viewAll").on("click", self.viewAllAnswers);
            $(".hideViewAllAnswers").on("click", self.hideViewAllAnswers);
        }, 0);
    }

    viewAllAnswers(event) {
        var index = $(event.currentTarget).attr("data-index");
        $(`#allAnswers${index}`).fadeIn();
    }

    hideViewAllAnswers(event) {
        $(event.currentTarget).parent().parent().parent().fadeOut();
    }

    @on('click .filterRatings')
    filterRatings(event) {
        const filter = $(event.currentTarget).data("filter");
        $(".filterButtons").find(".active").removeClass("active");
        $(event.currentTarget).addClass("active");
        let filtersMap;

        switch (filter) {
            case "great":
                filtersMap = {"minValue": 0.66, "maxValue": 1.0};
                this.surveyResponderCollection.url = this.surveyCollectionUrl + "?" + "filtersMap=" + encodeURIComponent(JSON.stringify(filtersMap));
                break;
            case "okay":
                filtersMap = {"minValue": 0.35, "maxValue": 0.66};
                this.surveyResponderCollection.url = this.surveyCollectionUrl + "?" + "filtersMap=" + encodeURIComponent(JSON.stringify(filtersMap));
                break;
            case "notGood":
                filtersMap = {"minValue": 0.0, "maxValue": 0.35};
                this.surveyResponderCollection.url = this.surveyCollectionUrl + "?" + "filtersMap=" + encodeURIComponent(JSON.stringify(filtersMap));
                break;
            default: //"all"
                this.surveyResponderCollection.url = this.surveyCollectionUrl;
                break;
        }

        this.surveyResponderCollection.getFirstPage().done(response => {
            this.showOrHidePagination(response);
        });
    }

    showOrHidePagination(resp) {
        if (!resp) {
            $("#noratingssearch").show();
            $("#pagination-report").hide();
            return;
        }
        if (resp.count === 0 && resp.data.length === 0) {
            $("#noratingssearch").show();
            $("#pagination-report").hide();
        } else if (resp.count < 11 && resp.data > 0) {
            $("#pagination-report").hide();
        } else {
            $("#pagination-report").show();
        }
    }
}

export default SatisfactionView;
